import { resolveTier as n } from "./resolve.js";
const i = "FYT", t = {
  freeMonthly: 20,
  aiCoachMonthly: 500,
  creditsPerUsd: 2e3
}, a = (e, r = t) => !Number.isFinite(e) || e <= 0 ? 1 : Math.max(1, Math.round(e * r.creditsPerUsd)), c = (e, r = t) => {
  switch (n(e)) {
    case "unlimited":
      return 1 / 0;
    case "aiCoach":
      return r.aiCoachMonthly;
    case "pro":
    case "free":
    default:
      return r.freeMonthly;
  }
};
export {
  t as DEFAULT_CREDIT_CONFIG,
  i as FYT_CURRENCY_CODE,
  a as creditsForRun,
  c as monthlyAllotmentFor
};
